import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="max-w-6xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
      <h1 className="text-3xl font-extrabold text-gray-900 mb-8">Privacy Policy & Refund Policy</h1>
      <div className="prose prose-lg text-gray-700 max-w-none">
        <p className="text-lg mb-6">
          <strong>Effective Date:</strong> July 15, 2025<br />
          Welcome to the official website of Badminton Event 2025 (“we,” “us,” or “our”). Your privacy is important to us, and we are committed to protecting the personal information you share with us. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website: <a href="https://events.tieupsolutions.com" target="_blank" rel="noopener noreferrer">events.tieupsolutions.com</a>
        </p>
        <div className="space-y-8">
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Information We Collect</h2>
            <p className="mb-2 font-semibold">a. Personal Information</p>
            <ul className="list-disc pl-6 space-y-1">
          <li>Full Name</li>
          <li>Email Address</li>
          <li>Phone Number</li>
          <li>Date of Birth</li>
          <li>Gender (optional)</li>
          <li>Address (for ticket delivery or identification purposes)</li>
          <li>Emergency Contact Details (if required during registration)</li>
        </ul>
            <p className="mt-4 mb-2 font-semibold">b. Payment Information</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Credit/Debit card details or other payment information (collected via secure third-party payment gateways)</li>
            </ul>
            <p className="mt-4 mb-2 font-semibold">c. Technical Information</p>
            <ul className="list-disc pl-6 space-y-1">
          <li>IP address</li>
          <li>Browser type and version</li>
          <li>Pages visited and time spent on the website</li>
          <li>Device information (such as mobile device ID, OS)</li>
        </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">2. How We Use Your Information</h2>
            <ul className="list-disc pl-6 space-y-1">
          <li>Process registrations and ticket purchases</li>
          <li>Send updates and event-related notifications</li>
          <li>Communicate important announcements (e.g., schedule changes, location updates)</li>
          <li>Respond to inquiries and provide customer support</li>
          <li>Improve our website’s performance and user experience</li>
          <li>Ensure safety, compliance, and security during the event</li>
        </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Sharing of Information</h2>
        <p>We do not sell, trade, or rent your personal information to third parties. However, we may share your information with:</p>
            <ul className="list-disc pl-6 space-y-1">
          <li>Event partners or sponsors (with consent)</li>
          <li>Payment processing companies (for transactions)</li>
          <li>Government or legal authorities when required by law</li>
          <li>Emergency services in case of health or safety issues during the event</li>
        </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Data Security</h2>
        <p>We implement appropriate administrative, technical, and physical safeguards to protect your personal data. This includes SSL encryption, secure server infrastructure, and limited access to personal information.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Cookies and Tracking Technologies</h2>
        <p>Our website may use cookies or similar technologies to enhance user experience and collect site analytics. You can manage or disable cookies through your browser settings.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Third-Party Links</h2>
        <p>Our website may contain links to third-party websites. We are not responsible for the privacy practices of these websites. Please review their privacy policies before providing any personal information.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Children’s Privacy</h2>
        <p>This website is not intended for children under the age of 13. We do not knowingly collect personal data from minors without parental consent.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Your Rights</h2>
        <p>Depending on your location, you may have the right to:</p>
            <ul className="list-disc pl-6 space-y-1">
          <li>Access the personal data we hold about you</li>
          <li>Correct inaccuracies in your information</li>
          <li>Request deletion of your data</li>
          <li>Opt-out of marketing communications</li>
        </ul>
            <p className="mt-2">To exercise these rights, please contact us at <a href="mailto:yuvi@tieupsolutions.com">yuvi@tieupsolutions.com</a>.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Changes to This Privacy Policy</h2>
        <p>We reserve the right to update this Privacy Policy at any time. Updates will be posted on this page with a revised effective date.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Contact Us</h2>
            <ul className="list-none pl-0 space-y-1">
              <li><strong>Email:</strong> <a href="mailto:yuvi@tieupsolutions.com">yuvi@tieupsolutions.com</a></li>
              <li><strong>Phone:</strong> +91 83444 05645</li>
              <li><strong>Address:</strong> First Floor, East Coast Rd, WOCO Spaces, Tieup Solutions Pvt. Ltd, 4/222, Palavakkam, Tamil Nadu 600041</li>
        </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Refund Policy</h2>
            <p>Once the registration is completed, no refunds will be issued through our website. Please ensure that you review all event details carefully before confirming your registration.</p>
          </section>
        </div>

        <div className="mt-12 p-6 bg-gray-50 rounded-lg">
          <p className="text-sm text-gray-600 text-center">
            <strong>Last updated:</strong> July 15, 2025<br />
            <strong>Event:</strong> Shuttle Clash (Badminton Event 2025)<br />
            <strong>Organizer:</strong> Tieup Solutions Pvt. Ltd (GSTIN: 33AAJCT7522Q1ZR)
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
